import { useEffect } from "react";
import { connect } from "react-redux";
import parametroMaquinaCartaoService from "src/App/services/MaquinaCartao/ParametroMaquinaCartaoService";
import jwtService from "src/App/services/jwtService";
import messageService from "src/App/services/MessageService";

const moeda = valor => Number(valor || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export function BaixaCartaoAoEntrar({ usuarioCodigo, empresaCodigo }) {
  useEffect(() => {
    if (!usuarioCodigo || !empresaCodigo) return;
    let ativo = true;
    const mesmaEmpresa = () => {
      const usuario = jwtService.getUsuarioLogado();
      return ativo && !usuario?.adminLogin &&
        String(usuario?.codigo) === String(usuarioCodigo) &&
        String(usuario?.empresaLogada?.codigo) === String(empresaCodigo);
    };
    if (!mesmaEmpresa()) return;

    parametroMaquinaCartaoService.executarAoEntrar({ usuarioCodigo, empresaCodigo })
      .then(resumo => {
        if (!mesmaEmpresa()) return;
        const pendentes = (resumo.itens || []).filter(item =>
          !["BAIXADA", "AGUARDANDO", "JA_RECEBIDA"].includes(item.situacao)).length;
        if (resumo.baixadas > 0) {
          messageService.successMessage(
            `${resumo.baixadas} conta(s) de cartão recebida(s). ${moeda(resumo.valorLiquido)} creditado(s) no banco com a data de hoje.`,
            { title: "Recebimento automático de cartões", duration: 9000 },
          );
        }
        if (pendentes > 0) {
          messageService.warningMessage(
            `${pendentes} conta(s) de cartão continuam em aberto. Confira os motivos em Cadastros > Máquinas de cartão > Recebimento, no botão Baixar vencidos agora.`,
            { title: "Cartões com pendências", duration: 12000 },
          );
        }
      })
      .catch(() => {
        if (!mesmaEmpresa()) return;
        messageService.warningMessage(
          "Não foi possível confirmar o recebimento automático dos cartões. Confira em Cadastros > Máquinas de cartão > Recebimento antes de tentar novamente.",
          { title: "Confira os recebimentos de cartão", duration: 12000 },
        );
      });
    return () => { ativo = false; };
  }, [usuarioCodigo, empresaCodigo]);
  return null;
}

export default connect(state => ({
  usuarioCodigo: state.auth.usuario?.codigo,
  empresaCodigo: state.auth.empresaLogada?.codigo,
}))(BaixaCartaoAoEntrar);
